// Settings translations (Norwegian source catalog).
window.PlummeI18n.register('no', {
  'set.acc.assetAutomaticPostingExplanation': 'Avskrivninger bokføres automatisk for hver fullførte måned. Plumme tar igjen manglende måneder uten at du trenger å gjøre noe.',
  'set.acc.paymentDays': 'Standard betalingsfrist (dager)',
  'set.acc.paymentDaysHelp': 'Forfallsdato følger fakturadato med denne fristen. Du kan overstyre forfallsdato på den enkelte fakturaen.',
  'set.acc.paymentDaysInvalid': 'Velg en betalingsfrist fra 0 til 365 hele dager.',
  'set.acc.foreignCurrencyInvoices': 'Salg i utenlandsk valuta',
  'set.acc.foreignCurrencyInvoicesHelp': 'Vis dokumentvaluta og kursfelter i Nytt salg. La dette være av hvis du bare fakturerer i regnskapsvalutaen.',
  'set.acc.advancedVatDeduction': 'Avansert MVA-fradrag på kjøpslinjer',
  'set.acc.advancedVatDeductionHelp': 'Vis valg for helt eller delvis fradrag når dokumentet har MVA. Valget er normalt 100 %, og eksisterende avvik vises alltid.',
  'set.acc.openingAssets': 'Driftsmidler i åpningsbalansen',
  'set.acc.openingAssetsHelp': 'Registrer detaljene for eiendeler som allerede inngår i åpningsbalansen. Beløpene avstemmes mot åpningsbalansen, men eiendelene føres i eiendelsregisteret.',
  'set.acc.openingAssetsAction': 'Registrer eksisterende driftsmiddel',
  'set.acc.assetAutomation': 'Automatisk månedsbokføring av avskrivninger',
  'set.acc.assetAutomationHelp': 'Kontroller beløp og periode før du bekrefter. Aktivering bokfører utestående fullførte måneder og godkjenner videre automatikk. Pause fjerner ingen bokførte bilag.',
  'set.acc.assetAutomationActive': 'Aktiv for valgt regnskapsår.',
  'set.acc.assetAutomationOff': 'Deaktivert for valgt regnskapsår.',
  'set.acc.assetAutomationReview': 'Satt på vent. Kontroller og godkjenn det oppdaterte eiendelsgrunnlaget før videre automatisk bokføring.',
  'set.acc.assetAutomationEnableNote': 'Godkjent automatisk månedlig bokføring av regnskapsmessige avskrivninger.',
  'set.acc.assetAutomationDisableNote': 'Automatisk månedlig bokføring stoppet av bruker.',
  'set.bank.activeFromHelp': 'Oppfølging forventer bare bankutskrifter fra denne datoen og fremover.',
  'set.bank.noReconciliationHelp': 'Uten bankavstemming må du selv kontrollere at alle bankbevegelser er bokført én gang, at banksaldo stemmer med regnskapet, og at private og firmarelaterte betalinger ikke blandes.',
  'set.bank.newAccount': 'Ny bankkonto',
  'set.bank.invoiceDeleteBlocked': 'Fakturakonto kan ikke slettes før en annen konto er valgt',
  'set.bank.deleteOrDisable': 'Slett eller deaktiver konto',
  'set.bank.openingBalanceHelp': 'Bankens saldo ved utgangen av siste dato som allerede er avstemt. Den er kontrollanker for bankavstemmingen, men bokfører ikke inngående balanse; IB føres under Regnskap med en motkonto.',
  'set.bank.openingBalanceDateHelp': 'Plumme begynner bankavstemmingen dagen etter denne datoen.',
  'set.bank.setupValidation.date': "Velg en gyldig dato.",
  'set.bank.setupValidation.year': 'Datoen må ligge i regnskapsåret {year}. Bytt regnskapsår hvis du skal registrere en annen oppstart.',
  'set.bank.setupValidation.amount': "Fyll inn bankens dokumenterte saldo. Bruk 0 hvis kontoen var tom.",
  'set.bank.setupValidation.counter': 'Velg motkonto fra den dokumenterte inngående balansen.',
  'set.bank.setupTitle': 'Sett opp startsaldo',
  'set.bank.setupIntro': 'Registrer bankens dokumenterte saldo og den balanserte regnskapsføringen i én flyt. Plumme gjetter aldri motkonto.',
  'set.bank.setupYearStart': 'Start ved nytt regnskapsår',
  'set.bank.setupYearStartHelp': 'Velg dette når regnskapet i Plumme begynner 1. januar. Bruk bankens saldo per 31. desember året før, også når saldoen er 0.',
  'set.bank.setupMidYear': 'Flytt til Plumme midt i året',
  'set.bank.setupMidYearHelp': 'Velg dette bare hvis du flytter et eksisterende regnskap fra et annet system midt i året. Datoen er overtakelsesdatoen, ikke datoen du gjør årsavslutningen.',
  'set.bank.setupNewAccount': 'Ny bankkonto i et løpende regnskap',
  'set.bank.setupNewAccountHelp': 'Velg dette når regnskapet allerede føres i Plumme og du åpner en ny bankkonto. Pengene som overføres til kontoen skal bokføres som en vanlig transaksjon.',
  'set.bank.setupUnsupported': 'Samlet bank- og regnskapsstartsaldo støttes foreløpig bare for norske NOK-kontoer. Bruk de separate regnskaps- og bankflytene for denne kontoen.',
  'set.bank.setupNewAccountTitle': 'Bokfør den faktiske overføringen',
  'set.bank.setupNewAccountBody': 'Opprett eller importer transaksjonen som flyttet pengene til kontoen. Når hovedboken stemmer med banken, kan bankavstemmingen starte uten en ny inngående balanse.',
  'set.bank.setupTransitionDate': 'Første dag i Plumme',
  'set.bank.setupTransitionYearHint': 'Første dag i valgt regnskapsår ({year}).',
  'set.bank.setupTransitionMidYearHint': 'Datoen Plumme overtar fra det tidligere systemet.',
  'set.bank.setupEvidenceDate': 'Bankens saldo per',
  'set.bank.setupEvidenceDateHint': 'Beregnes som dagen før Plumme overtar.',
  'set.bank.setupBankBalance': 'Bankens dokumenterte saldo',
  'set.bank.setupBankBalanceHint': 'Bruk saldoen fra kontoutskriften på skjæringsdatoen.',
  'set.bank.setupLedgerAccount': 'Bankkonto i hovedboken',
  'set.bank.setupCounterAccount': 'Motkonto i inngående balanse',
  'set.bank.setupCounterHelp': 'Velg hvor bankbeløpet kommer fra. Dette kan ikke bestemmes av banksaldoen alene.',
  'set.bank.setupChooseCounter': 'Velg motkonto',
  'set.bank.setupNoCounter': 'Ingen motkonto nødvendig ved nullsaldo',
  'set.bank.setupNoCounterMatches': 'Ingen balansekontoer matcher søket.',
  'set.bank.setupManagedInBank': 'Koblet til startsaldoen under Innstillinger - Bank',
  'set.bank.setupMidYearWarning': 'Banksaldoen er bare én del av overgangen. Legg også inn eller importer øvrige balanse-, resultat- og MVA-tall fra tidligere system under Regnskap.',
  'set.bank.setupPreview': 'Dette lagres samlet',
  'set.bank.setupPreviewText': 'Bankbevis: {amount} per skjæringsdato. Regnskaps-IB: {bank} mot {counter}.',
  'set.bank.setupNotChosen': 'motkonto ikke valgt',
  'set.bank.setupSave': 'Lagre startsaldo og IB',
  'set.bank.setupSaveError': 'Kunne ikke lagre startsaldoen.',
  'set.bank.setupPostingNote': 'Bankens startsaldo – {account}',
  'set.bank.setupButton': 'Sett opp eller korriger startsaldo',
  'set.bank.setupSummaryTitle': 'Bankens saldo ved oppstart',
  'set.bank.setupSummaryEmpty': 'Startsaldo og regnskaps-IB er ikke satt opp.',
  'set.bank.setupSummaryValue': '{amount} per {date}',
  'set.bank.setupSaved': 'Startsaldo og inngående balanse er lagret',
  'set.bank.setupSaveAccountFirst': 'Lagre bankkontoen først. Deretter kan startsaldo og inngående balanse settes opp samlet.',
  'set.bank.iban': 'IBAN',
  'set.bank.bic': 'BIC',
  'set.bank.showIbanBicOnInvoice': 'Vis IBAN og BIC på faktura',
  'set.role.owner': 'Eier',
  'set.access.noOrgNumber': 'Uten org.nr.',
  'set.access.onboardingUnavailable': 'Onboarding er ikke lastet.',
  'set.access.members': 'Medlemmer',
  'set.access.membersSub': 'Eier og administratorer kan fjerne aktive tilganger. Eier må overføres før eierens egen tilgang kan fjernes.',
  'set.access.membersOnlyAdmin': 'Bare eier og administrator kan administrere medlemmer.',
  'set.access.selfRemoveHelp': 'Du kan likevel fjerne din egen tilgang hvis du ikke er eier.',
  'set.access.you': 'deg',
  'set.access.remove': 'Fjern',
  'set.access.membersEmpty': 'Aktive medlemmer vises for eier og administrator.',
  'set.access.removeSelf': 'Fjern min tilgang',
  'set.access.transferTitle': 'Overfør eierskap',
  'set.access.transferSub': 'Send en kontrollert invitasjon til ny eier. Eierskapet flyttes først når mottakeren logger inn og godtar.',
  'set.access.transferOnlyOwner': 'Bare eier kan overføre eierskap.',
  'set.access.transferAdminHelp': 'Administratorer kan invitere samarbeidspartnere, men kan ikke bytte eier.',
  'set.access.newOwnerEmail': 'Ny eiers e-post',
  'set.access.afterTransferRole': 'Din tilgang etter overføring',
  'set.access.roleAdministrator': 'Administrator',
  'set.access.transferReason': 'Grunn / notat til audit',
  'set.access.transferReasonPlaceholder': 'F.eks. solgt foretaket eller opprettet for kunde',
  'set.access.sendTransfer': 'Send eierskifte',
  'set.access.ownershipTransfer': 'Eierskifte',
  'set.access.expired': 'Utløpt',
  'set.access.viewAccept': 'Se og godta',
  'set.access.unknown': 'ukjent',
  'set.access.resend': 'Send på nytt',
  'set.tab.accounting': 'Regnskap',
  'set.tab.data': 'Data',
  'set.companyEmailHint': 'Hentes fra innloggingen din.',
  'set.countryLocked': 'Land velges når foretaket opprettes og kan ikke endres her. Kontakt support ved feil.',
  'set.inboxUpdatedAt': 'Sist oppdatert {date}',
  'set.inboxCopied': 'E-post kopiert',
  'set.profileEmailHint': 'E-post endres ikke her, fordi Firebase kan kreve ny innlogging.',
  'set.subscriptionPlan': 'Plan: {plan}',
  'set.subscriptionInactive': 'Abonnement ikke aktivert',
  'set.subscriptionTrialUntil': 'Prøveperiode til {date}',
  'set.subscriptionChooseHelp': 'Velg plan for å starte checkout i Stripe.',
  'set.subscriptionDisconnected': 'Ikke koblet',
  'set.subscriptionCurrentPlan': 'Nåværende plan',
  'set.subscriptionChoosePlan': 'Velg {name}',
  'set.subscriptionFeature.bookkeeping': 'Bokføring',
  'set.subscriptionFeature.invoiceEmailEhf': 'Faktura på e-post og EHF',
  'set.subscriptionFeature.publicFiling': 'Innsending til det offentlige',
  'set.subscriptionFeature.invoiceEmail': 'Faktura på e-post',
  'set.subscriptionFeature.taxFigures': 'Tall for MVA og skattemelding',
  'set.subscriptionFeature.taxIntegration': 'Integrasjon mot Skatteetaten',
  'set.acc.setupTab': 'Oppsett',
  'set.acc.chartTab': 'Kontoplan',
  'set.acc.vatPeriodAnnual': 'Årlig',
  'set.acc.vatPeriodBimonthly': 'Annenhver mnd',
  'set.acc.vatPeriodMonthly': 'Månedlig',
  'set.acc.vatPeriodQuarterly': 'Kvartalsvis',
  'set.acc.vatPeriod.monthly': 'Månedlig',
  'set.acc.vatPeriod.bimonthly': 'Annenhver måned',
  'set.acc.vatPeriod.quarterly': 'Kvartalsvis',
  'set.acc.vatPeriod.semiannual': 'Halvårlig',
  'set.acc.vatPeriod.annual': 'Årlig',
  'set.acc.vatPeriodEffectiveYear': 'Gjelder fra år',
  'set.acc.vatPeriodEffectiveYearHelp': 'Oppgi året som står i vedtaket fra Skatteetaten. Endringen gjelder fra 1. januar i dette året. Et avsluttet år må gjenåpnes, og leverte MVA-meldinger må åpnes eller reverseres først.',
  'set.acc.vatPeriodEffectiveYearInvalid': 'Oppgi et gyldig år med fire siffer.',
  'set.acc.vatPeriodHistory': 'Historikk for MVA-termin',
  'set.acc.vatPeriodConfirmTitle': 'Er du sikker på at MVA-terminen skal endres?',
  'set.acc.vatPeriodConfirmText': 'Endringen gjelder fra 1. januar {year}. Kontroller at året samsvarer med vedtaket fra Skatteetaten. Tidligere år beholdes uendret. Et avsluttet år må gjenåpnes, og leverte MVA-meldinger må åpnes eller reverseres først.',
  'set.acc.vatPeriodConfirm': 'Bekreft endring',
  'set.acc.notVatRegisteredNotice': 'Når foretaket ikke er MVA-registrert, blir nye fakturaer satt til 0 % MVA. Kjøp kan fortsatt registreres med MVA på bilaget, men uten fradragsrett.',
  'set.acc.midYearText': 'Bruk denne hvis du flytter til Plumme midt i året og vil at rapportene skal fortsette med tall fra tidligere system.',
  'set.acc.openingSaved': 'Oppstartstall lagret',
  'set.acc.openingSavedFrom': 'Oppstartstall lagret fra {date}.',
  'set.acc.openingBalanceText': 'Bruk denne hvis du starter opp ved nytt regnskapsår og vil legge inn inngående balansetall fra foregående år.',
  'set.startup.linkedBalanceTitle': 'Inngående balanse følger med',
  'set.startup.linkedBalanceHelp': 'Dette er de samme balanselinjene som i veiviseren for inngående balanse. Banklinjer korrigeres under Innstillinger - Bank.',
  'set.acc.balanceBooked': 'Bokført {date} - {count} {lines}',
  'set.acc.line': 'linje',
  'set.acc.lines': 'linjer',
  'set.acc.enterAccountNumber': 'Legg inn kontonummer',
  'set.acc.equivalentHint': 'Styrer behandling i årsavslutning og skattemelding.',
  'set.acc.saveChart': 'Lagre kontoplan',
  'set.acc.equivalentShort': 'Tilsvarer',
  'set.acc.usedInHistory': 'Brukt i historikk',
  'set.acc.activate': 'Aktiver',
  'set.acc.editAccount': 'Rediger konto',
  'set.acc.deactivateUsed': 'Deaktiver brukt konto',
  'set.acc.deleteUnused': 'Slett ubrukt konto',
  'set.ib.intro': 'Her legger du inn inngående balansetall fra forrige regnskapsår. Bruk dette når du starter opp ved nytt år og vil at balansen skal stemme fra dag én i Plumme.',
  'set.ib.attachment': 'Vedlegg',
  'set.ib.uploadDocuments': 'Last opp dokumenter',
  'set.ib.uploading': 'Laster opp...',
  'set.ib.created': 'Opprettet',
  'set.ib.uploadReceipt': 'Last opp nytt bilag',
  'set.ib.emptyHelp': 'Du må legge til minst én linje før du kan opprette inngående balanse. Bruk knappen "Legg til ny linje" for å legge inn tallene fra forrige system.',
  'set.ib.postHelp': 'Bekreft at inngående balanse er korrekt og klar til bokføring. Du kan fortsatt endre den etterpå så lenge perioden er åpen.',
  'set.ib.draftFor': 'Utkast for inngående balanse for {date}',
  'set.ib.createdAt': 'Opprettet {date}',
  'set.ib.balanceHelp': 'Legg inn saldoen for hver konto fra det avsluttede regnskapet. Hele inngående balansen må ha like stor sum debet og kredit.',
  'set.ib.noteOptional': 'Merknad (valgfritt)',
  'set.ib.difference': 'Differanse',
  'set.ib.saveDraft': 'Lagre utkast',
  'set.ib.validationHelp': 'Kontroller at hver linje har konto og positivt beløp på bare én side, og at sum debet er lik sum kredit.',
  'set.ib.excludedRows': '{count} resultat- eller ukjente kontoer holdes utenfor ordinær IB. Kontroller dem i importgrunnlaget.',
  'set.transitionImport.confirmSigned': 'Bekreft kolonne og fortegn før import',
  'set.transitionImport.balanceColumn': 'Saldokolonne',
  'set.transitionImport.signConvention': 'Fortegnkonvensjon',
  'set.transitionImport.positiveDebit': 'Positivt er debet, negativt er kredit',
  'set.transitionImport.positiveCredit': 'Positivt er kredit, negativt er debet',
  'set.transitionImport.signExample': 'Eksempel: Med «positivt er debet» blir −427 473,92 kredit 427 473,92.',
  'set.transitionImport.confirmImport': 'Bekreft og forhåndsvis',
  'set.transitionImport.helpImage': 'SAF-T, Excel, CSV eller bilde. Dra inn eller lim inn med Ctrl+V.',
  'sd.deleteAllTitle': 'Slett alle {label}',
  'sd.deleteAllMessage': 'Slette alle {label} ({count})? Historiske fakturaer og bilag beholdes, men registeret tømmes. Dette kan ikke angres. Vi anbefaler å ta en eksport først.',
  'sd.label.customers': 'kunder',
  'sd.label.suppliers': 'leverandører',
  'sd.label.products': 'produkter',
  'sd.importing': 'Importerer...',
  'sd.documentReferenceMissing': 'Dokumentet mangler referanse til importpakken.',
  'sd.documentLinkFailed': 'Kunne ikke hente dokumentlenke.',
  'sd.documentOpenFailed': 'Kunne ikke åpne importdokumentet.',
  'sd.kind.voucher': 'Bilag',
  'sd.kind.inbox': 'Innboks',
  'sd.kind.bankReconciliation': 'Bankavstemminger',
  'sd.kind.company': 'Foretaksdokumenter',
  'sd.kind.invoice': 'Faktura',
  'sd.kind.quote': 'Tilbud',
  'sd.kind.creditNote': 'Kreditnota',
  'sd.kind.orderConfirmation': 'Ordrebekreftelse',
  'sd.kind.paymentReminder': 'Betalingspåminnelse',
  'sd.kind.otherCount': 'Andre {count}',
  'sd.kind.allCount': 'Alle {count}',
  'sd.reportCsv': 'Rapport CSV',
  'sd.reportXlsx': 'Rapport XLSX',
  'sd.openItems.exported': '{count} åpne poster eksportert',
  'sd.openItems.exportFailed': 'Kunne ikke eksportere rapporten.',
  'sd.openItems.title': 'Kontroller importerte åpne poster',
  'sd.openItems.count': 'åpne poster',
  'sd.openItems.remainingTotal': 'sum restbeløp',
  'sd.openItems.possibleDeviations': 'mulige avvik',
  'sd.openItems.search': 'Søk på navn, fakturanr, dato eller ark',
  'sd.filter.all': 'Alle',
  'sd.filter.customers': 'Kunder',
  'sd.filter.suppliers': 'Leverandører',
  'sd.openItems.checkDeviation': 'Sjekk avvik mot reskontrosaldo',
  'sd.openItems.deviation': '{label}: {party} avviker {amount}',
  'sd.unnamed': 'Uten navn',
  'sd.openItems.rowMeta': '#{invoice} · dato {date} · forfall {due}',
  'sd.openItems.empty': 'Ingen åpne importposter matcher filteret.',
  'sd.documents.title': 'Importert dokumentarkiv',
  'sd.documents.count': 'dokumenter',
  'sd.documents.types': 'typer',
  'sd.documents.packages': 'eksportpakker',
  'sd.documents.search': 'Søk på fil, år, bilagsnr eller intern sti',
  'sd.documents.sortType': 'Sorter: type',
  'sd.documents.sortYear': 'Sorter: år',
  'sd.documents.sortName': 'Sorter: filnavn',
  'sd.documents.basis': 'Arkivgrunnlag',
  'sd.documents.basisHelp': 'Dokumentene er lagret som importindeks mot original eksportpakke. De oppretter ikke fakturaer, kjøp, bilag eller innbokselementer automatisk.',
  'sd.documents.fallback': 'Dokument',
  'sd.documents.unknownPath': 'Ukjent sti i eksportpakken',
  'sd.documents.fetching': 'Henter...',
  'sd.documents.open': 'Åpne',
  'sd.documents.empty': 'Ingen importerte dokumenter matcher filteret.',
  'sd.ledger.title': 'Importert hovedbokarkiv',
  'sd.ledger.linesShown': 'historikklinjer i vist arkiv',
  'sd.ledger.debitShown': 'debet i vist utvalg',
  'sd.ledger.creditShown': 'kredit i vist utvalg',
  'sd.ledger.search': 'Søk på bilag, konto, tekst, dato eller kilde',
  'sd.ledger.allYears': 'Alle år',
  'sd.ledger.historyOnly': 'Kun historikk',
  'sd.ledger.historyHelp': 'Linjer her er lesbart importarkiv fra tidligere system. Summene over er debet/kredit for vist arkivutvalg, ikke omsetning. Linjene inngår ikke i Plumme-rapporter, MVA, skatt, bankavstemming eller live bilagsliste.',
  'sd.ledger.noText': 'Ingen tekst',
  'sd.ledger.linkedCount': '{count} tilknyttet bilag i dokumentarkivet',
  'sd.ledger.empty': 'Ingen importerte hovedboklinjer matcher filteret.',
  'sd.ledger.linkedTitle': 'Tilknyttede bilag',
  'sd.ledger.archiveDocument': 'Arkivdokument',
  'sd.ledger.archiveDocumentHelp': 'Dette er dokumentreferanser fra original eksportpakke. De oppretter ikke live bilag eller innbokselementer.',
  'sd.ledger.noDocumentDetails': 'Ingen dokumentdetaljer lagret for denne linjen.',
  'sd.ledger.showing': 'Viser {shown} av {total} treff for denne historikklinjen.',
  'sd.transition.exported': '{count} år eksportert',
  'sd.transition.exportFailed': 'Kunne ikke eksportere overgangsrapporten.',
  'sd.transition.title': 'Avstemming og overgangsrapport',
  'sd.transition.years': 'år',
  'sd.transition.openingLines': 'IB-linjer',
  'sd.transition.historyLines': 'historikklinjer',
  'sd.transition.warnings': 'kontrollvarsler',
  'sd.transition.control': 'Overgangskontroll',
  'sd.transition.controlHelp': 'Rapporten sammenstiller importert inngående balanse, reskontro, bank og hovedbokhistorikk per år. Tallene er kontrollgrunnlag og bokføres ikke automatisk.',
  'sd.transition.latestSubledger': 'Importert reskontrosaldo uten eget år vises på {year} som seneste importerte reskontro.',
  'sd.transition.rowSummary': '{opening} IB-linjer · {accounts} historiske kontosaldoer · {history} historikklinjer · bank IB {bank}',
  'sd.transition.warningCount': '{count} varsel',
  'sd.transition.discrepancy': 'Avvik {amount}',
  'sd.transition.historicalBalance': 'Historisk saldo',
  'sd.transition.balanceSequence': 'IB / endring / UB',
  'sd.transition.historicalResult': 'Historisk resultat',
  'sd.transition.incomeCost': 'Inntekt {income} · kost {cost}',
  'sd.transition.itemsDeviation': '{count} poster · avvik {amount}',
  'sd.transition.supplierSubledger': 'Leverandørreskontro',
  'sd.transition.ledgerArchive': 'Hovedbokarkiv',
  'sd.transition.empty': 'Ingen importerte overgangstall å vise ennå.',
  'sd.vatTax.exported': '{count} linjer eksportert',
  'sd.vatTax.exportFailed': 'Kunne ikke eksportere MVA/skatt-historikken.',
  'sd.vatTax.title': 'MVA og skatt fra importhistorikk',
  'sd.vatTax.periods': 'MVA-terminer',
  'sd.vatTax.netVat': 'netto MVA',
  'sd.vatTax.resultBeforeTax': 'resultat før skatt',
  'sd.vatTax.basis': 'Historisk kontrollgrunnlag',
  'sd.vatTax.basisHelp': 'MVA summeres fra importerte 270x/271x-kontoer per termin. SAF-T MVA-koder vises som kodegrunnlag der eksportfilen inneholder dem. Dette lager ikke nye MVA-meldinger, bilag eller skatteposteringer.',
  'sd.vatTax.yearSummary': '{count} terminer · resultat før skatt {amount}',
  'sd.vatTax.archive': 'Arkiv',
  'sd.vatTax.period': 'Termin {number} · {label}',
  'sd.vatTax.outputInput': 'Utg. {output} · inng. {input}',
  'sd.vatTax.empty': 'Ingen importert MVA/skatt-historikk å vise ennå.',
  'sd.vatTax.codes': 'SAF-T MVA-koder',
  'sd.vatTax.showing': 'Viser {shown} av {total}',
  'sd.vatTax.code': '{year}-{month} kode {code}',
  'sd.vatTax.baseVat': 'Grunnlag {base} · MVA {vat} · {rate}%',
  'sd.resetMessage': 'Dette sletter permanent alle regnskaps- og driftsdata i valgt foretak: fakturaer, bilag, betalinger, kunder, leverandører, produkter, lønn, bankdata, inngående balanse, importarkiv, filer og alle løpenumre. Handlingen kan ikke angres. Ta en komplett eksport først dersom noe skal beholdes.',
  'sd.resetPreserved': 'Selve foretaksprofilen, medlemmer, abonnement og integrasjonskoblinger beholdes. Bruk «Slett foretak» dersom også dette skal fjernes.',
  'sd.resetPhrase': 'BEKREFT',
  'sd.resetTypeLabel': 'Skriv {phrase} for å aktivere nullstilling',
  'sd.resetTypeHint': 'Knappen forblir deaktivert til teksten er skrevet nøyaktig.',
  'sd.resetConfirm': 'Slett og nullstill alt',
  'sd.resetComplete': 'Alle regnskaps- og driftsdata er slettet. Foretaket er nullstilt.',
  'sd.resetFailed': 'Kunne ikke fullføre nullstillingen.',
  'sd.deleteBusinessMessage': 'Planlegge sletting av valgt foretak om 30 dager? Foretaket, dataene og tilgangen fjernes etter karenstiden. Du kan avbryte slettingen før fristen.',
  'sd.deleteBusinessConfirm': 'Planlegg sletting',
  'sd.customersTitle': 'Import / Eksport av Kunder',
  'sd.suppliersTitle': 'Import / Eksport av Leverandører',
  'sd.productsTitle': 'Import / Eksport av Produkter',
  'sd.invoicesTitle': 'Import / Eksport av Faktura',
  'sd.vouchersTitle': 'Import / Eksport av Bilag',
  'sd.supportedFormats': 'Støttede importformater: .xlsx og .csv.',
  'sd.productsHelp': 'Importer og eksporter produkter med mal-kolonner. Støttede importformater: .xlsx og .csv.',
  'sd.invoicesHelp': 'Eksporter fakturaer som CSV, eller importer nye fakturaer med mal.',
  'sd.vouchersHelp': 'Eksporter bilagsoversikt eller bokføringslinjer. Import analyseres trygt som en komplett eksportpakke.',
  'sd.importInvoices': 'Importer fakturaer',
  'sd.buildingExport': 'Bygger eksportpakke...',
  'sd.exportAll': 'Eksporter alt (.zip)',
  'sd.technicalJson': 'Teknisk JSON',
  'sd.analyzing': 'Analyserer...',
  'sd.importOtherSystem': 'Importer fra annet system',
  'sd.reviewOpenItems': 'Kontroller åpne poster',
  'sd.documentArchive': 'Dokumentarkiv',
  'sd.ledgerArchive': 'Hovedbokarkiv',
  'sd.transitionReport': 'Overgangsrapport',
  'sd.vatTaxHistory': 'MVA/skatt-historikk',
  'sd.latestAnalysis': 'Siste analyse: {files} filer, {saft} SAF-T, {excel} Excel, {vouchers} bilagsfiler. Status: {status}.',
  'sd.analyzed': 'analysert',
  'sd.reanalyze': 'Reanalyser samme fil',
  'sd.reread': 'Les av importfil på nytt',
  'sd.rereadHelp': 'Siste importfil er lagret, men analysen er ikke ferdig eller feilet.',
  'sd.importProposal': 'Forslag: {accounts} saldokontoer, {customers} kunder, {suppliers} leverandører, {products} produkter, {customerInvoices} åpne kundefakturaer, {supplierInvoices} åpne leverandørfakturaer, {balances} inngående balanser, {documents}, {ledger}.',
  'sd.countShown': '{shown}+ {label} (viser {shown} av {total})',
  'sd.label.archiveDocuments': 'arkivdokumenter',
  'sd.label.historyLines': 'historikklinjer',
  'sd.saftTitle': 'Eksport SAF-T',
  'sd.saftHelp': 'Eksporter SAF-T Financial XML (beta), eller importer kontoplan, parter og inngående balanse fra SAF-T XML.',
  'sd.importSaft': 'Importer SAF-T (MVP)',
});
